/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutInterviewerMetricsExposure = typeof OrgSettingsPutInterviewerMetricsExposure[keyof typeof OrgSettingsPutInterviewerMetricsExposure] | null;


export const OrgSettingsPutInterviewerMetricsExposure = {
  aggregate_only: 'aggregate_only',
  named_self_admins: 'named_self_admins',
  named_all: 'named_all',
} as const;
